import { Validator } from '@vista-digital/validator';
export const defaultOccMemberPaymentCardsConfig = {
    expiringSoonThresholdInMonths: 1
};
export const occMemberPaymentCardsConfigValidator = Validator.object({
    expiringSoonThresholdInMonths: Validator.number({ min: 1 })
});
//# sourceMappingURL=payment-cards.js.map